export default function EmailAccount() {
  return <span>brendankohrc@gmail.com</span>;
}
